import { Button, Typography, useTheme } from '@mui/material';

interface ISubpageNavButtonProps {
    title: string;
    buttonCaption: string;
    onClick: () => void;
    disable?: boolean
}

export function SubpageNavButton({ onClick, buttonCaption, title, disable = false }: Readonly<ISubpageNavButtonProps>) {
    const theme = useTheme();

    return (
        <Button
            onClick={onClick}
            disabled={disable}
            sx={{
                padding: '24px',
                width: '25%',
                flexDirection: 'column',
                alignItems: 'flex-start',
                textTransform: 'none',
                border: `1px ${theme.palette.info.dark} solid`,
                borderRadius: '4px',
                backgroundColor: 'background.paper',
            }}
        >
            <Typography
                color={theme.palette.secondary.dark}
                paddingBottom={'2rem'}
            >
                {title}
            </Typography>
            <Typography
                variant={'caption'}
                color={disable ? theme.palette.primary.light : theme.palette.primary.accent}
                fontWeight={'600'}
            >
                {buttonCaption}
            </Typography>
        </Button>
    );
}
